import React, { useRef, useState, useEffect, useContext } from 'react';
import DataContext from './DataContext';
import { send, getToken, thinqSTT, postLog } from './DataLoader';
import string from '../../asset/language/string.json';
import Error from '../page/Error';
import base62 from 'uuid-base62';
import { osName, isMobile } from 'react-device-detect';
import Debug from './Debug';
import { useToasts } from 'react-toast-notifications';
import {
  makeDateMessage,
  makeTXMessage,
  makeSLMessage,
  makeTLMessage,
  makeSGMessage,
  convertMessage,
  convertDebugMessage,
} from './DataConvert';
import InputContext from './InputContext';
import moment from 'moment';
import { Base64 } from 'js-base64';

// 로컬 작업시 test 데이터 추가
const testMessages = {
  //http://collab.lge.com/main/display/LIVECHAT/04.+Carousel#id-04.Carousel-SubspackageCard
  //color값 - http://clm.lge.com/issue/secure/attachment/1631260/1631260_%EC%B0%A8%EC%84%B8%EB%8C%80%EC%BB%AC%EB%9F%AC%EC%B9%A9.txt
  '/SUBSP': [
    {
      type: 'SubspackageCard',
      mine: false,
      items: [
        {
          link: {
            type: 'external',
            product_image_url:
              'https://www.lge.co.kr/kr/images/washing-machines/md10220828/md10220828-350x350.jpg',
            product_image_mobile_url:
              'https://www.lge.co.kr/kr/images/washing-machines/md10220828/md10220828-350x350.jpg',
            product_link_url:
              'https://www.lge.co.kr/care-solutions/washing-machines/fx21wnc?dpType=upCareTab&chatbot=y',
            product_title: 'LG 트롬 오브제컬렉션',
            product_name: 'FX21WNC',
          },
          free_trial_list: null,
          product_spec: [
            {
              label: '용량',
              value: '21kg/25kg',
            },
            {
              label: '키높이 수납함',
              value: '유/무',
            },
          ],
          product_color: {
            key: 'siblingList',
            value: ['nature-green', 'nature-beige', 'washing_lily-white'],
          },
          product_badge: '멤버십 7만P (4~6년 계약시)',
          product_price: {
            product_master_price: '35,900',
          },
          buttons: [
            {
              label: '구독신청',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.lge.co.kr/care-solutions/washing-machines/fx21wnc?dpType=upCareTab&chatbot=y',
                mobile_url:
                  'https://www.lge.co.kr/care-solutions/washing-machines/fx21wnc?dpType=upCareTab&chatbot=y',
                enable: 'Y',
              },
            },
          ],
        },
        {
          link: {
            type: 'external',
            product_image_url:
              'https://www.lge.co.kr/kr/images/lsc/assets/images/product/CNT-1013/Z492GBB14ES_pc.jpg',
            product_image_mobile_url:
              'https://www.lge.co.kr/kr/images/lsc/assets/images/product/CNT-1013/Z492GBB14ES_pc.jpg',
            product_link_url:
              'https://www.lge.co.kr//care-solutions/subs-package/detail/CNT-1013?chatbot=y',
            product_title: 'LG 디오스 오브제컬렉션 김치톡톡',
            product_name: 'CNT-1013',
          },
          free_trial_list: [],
          product_spec: [
            {
              label: '용량',
              value: '491L',
            },
            {
              label: '기본형 케어십',
              value: '냉장고 가전세척 서비스',
            },
          ],
          product_color: {
            key: 'siblingList',
            value: ['beige_beige'],
          },
          product_badge: '멤버십 7만P (4~6년 계약시)',
          product_price: {
            product_master_price: '107,900',
          },
          buttons: [
            {
              label: '구독신청',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.lge.co.kr//care-solutions/subs-package/detail/CNT-1013?chatbot=y',
                mobile_url:
                  'https://www.lge.co.kr//care-solutions/subs-package/detail/CNT-1013?chatbot=y',
                enable: 'Y',
              },
            },
          ],
        },
        {
          link: {
            type: 'external',
            product_image_url: 'https://www.lge.co.krNone',
            product_image_mobile_url: 'https://www.lge.co.krNone',
            product_link_url:
              'https://www.lge.co.kr//care-solutions/subs-package/detail/CNT-1008?chatbot=y',
            product_title:
              'LG 디오스 오브제컬렉션 노크온 더블매직스페이스 (수도관 연결형)',
            product_name: 'CNT-1008',
          },
          free_trial_list: [],
          product_spec: [
            {
              label: '용량',
              value: '857L',
            },
            {
              label: '기본형 케어십',
              value: '냉장고 가전세척 서비스',
            },
          ],
          product_color: {
            key: 'siblingList',
            value: [
              'beige_beige',
              'creamwhite_creamwhite',
              'pink_beige',
              'beige_claybrown',
              'claybrown_beige',
              'clay_pink_beige',
              'clay_mint_beige',
              'cream-sky_cream-white',
            ],
          },
          product_badge: '멤버십 7만P (4~6년 계약시)',
          product_price: {
            product_master_price: '101,900',
          },
          buttons: [
            {
              label: '구독신청',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.lge.co.kr//care-solutions/subs-package/detail/CNT-1008?chatbot=y',
                mobile_url:
                  'https://www.lge.co.kr//care-solutions/subs-package/detail/CNT-1008?chatbot=y',
                enable: 'Y',
              },
            },
          ],
        },
      ],
      id: '1l5MAcK1pSYQQH6OOaowtW',
      isOld: false,
    },
  ],
  // http://collab.lge.com/main/display/LIVECHAT/04.+Carousel#id-04.Carousel-SubscriptionCard
  '/SUBS': [
    {
      type: 'SubscriptionCard',
      mine: false,
      items: [
        {
          link: {
            type: 'external',
            product_image_url:
              'https://www.lge.co.kr/kr/images/subscription/lg-cleaners/md09776839/md09776839-450x450.jpg',
            product_image_mobile_url:
              'https://www.lge.co.kr/kr/images/subscription/lg-cleaners/md09776839/md09776839-350x350.jpg',
            product_link_url:
              'https://www.lge.co.kr//subscription/lg-cleaners/a9000-sc06r?chatbot=y',
            product_title: '코드제로 A9 케어십 회수관리 서비스',
            product_name: 'A9000-SC06R',
          },
          product_status: '판매',
          product_price: {
            product_master_price: '9,900',
            product_obs_price: '',
            discount_rate: '0%',
            promotion_yn: 'N',
            benefits: [],
          },
          base_info: [
            {
              ValueName: '회수관리',
              Name: '서비스 유형',
            },
            {
              ValueName: '6개월',
              Name: '서비스 주기',
            },
          ],
          buttons: [
            {
              label: '구독 담기',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.lge.co.kr//subscription/lg-cleaners/a9000-sc06r?chatbot=y',
                mobile_url:
                  'https://www.lge.co.kr//subscription/lg-cleaners/a9000-sc06r?chatbot=y',
                enable: 'Y',
              },
            },
          ],
        },
        {
          link: {
            type: 'external',
            product_image_url:
              'https://www.lge.co.kr/kr/images/subscription/lg-cleaners/md10001832/md10001832-450x450.jpg',
            product_image_mobile_url:
              'https://www.lge.co.kr/kr/images/subscription/lg-cleaners/md10001832/md10001832-350x350.jpg',
            product_link_url:
              'https://www.lge.co.kr//subscription/lg-cleaners/a9001-sc12r?chatbot=y',
            product_title: '코드제로 A9 케어십 회수관리 서비스 (올인원타워 전용 케어형)',
            product_name: 'A9001-SC12R',
          },
          product_status: '판매',
          product_price: {
            product_master_price: '11,900',
            product_obs_price: '11,900',
            discount_rate: '0%',
            promotion_yn: 'N',
            benefits: [],
          },
          base_info: [
            {
              ValueName: '회수관리',
              Name: '서비스 유형',
            },
            {
              ValueName: '12개월',
              Name: '서비스 주기',
            },
          ],
          buttons: [
            {
              label: '구독 담기',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.lge.co.kr//subscription/lg-cleaners/a9001-sc12r?chatbot=y',
                mobile_url:
                  'https://www.lge.co.kr//subscription/lg-cleaners/a9001-sc12r?chatbot=y',
                enable: 'Y',
              },
            },
          ],
        },
        {
          link: {
            type: 'external',
            product_image_url:
              'https://www.lge.co.kr/kr/images/subscription/lg-cleaners/md09776839/md09776839-450x450.jpg',
            product_image_mobile_url:
              'https://www.lge.co.kr/kr/images/subscription/lg-cleaners/md09776839/md09776839-350x350.jpg',
            product_link_url:
              'https://www.lge.co.kr//subscription/lg-cleaners/a9000-sc06r?chatbot=y',
            product_title: '홈브루 캡슐 패키지 정기배송',
            product_name: 'B-ALL-SCNND',
          },
          product_status: '판매',
          product_price: {
            product_master_price: '24,000',
            product_obs_price: '20,400',
            discount_rate: '15%',
            promotion_yn: 'Y',
            benefits: [],
          },
          base_info: [
            {
              ValueName: '회수관리',
              Name: '서비스 유형',
            },
            {
              ValueName: '6개월',
              Name: '서비스 주기',
            },
          ],
          buttons: [
            {
              label: '구독 담기',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.lge.co.kr//subscription/lg-cleaners/a9000-sc06r?chatbot=y',
                mobile_url:
                  'https://www.lge.co.kr//subscription/lg-cleaners/a9000-sc06r?chatbot=y',
                enable: 'Y',
              },
            },
          ],
        },
      ],
      id: '2JxCnKULShbMWPqOVrxUq1',
      isOld: false,
    },
  ],

  '/DCL': [
    {
      type: 'DCL',
      mine: false,
      id: '2CoRKhlk1MgLESvAmLgBAZ',
      isOld: false,
      items: [
        {
          message_seq: '',
          ord_shop: '6.베스트샵 서초점',
          ord_header_no: '1091009121',
          deliv_wish_ymd: '',
          deliv_type: 'P',
          dev_status_type: 'complete',
          tracking_url: '',
          model_info: [
            {
              ord_no: '1091009121-1.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: '19MB35PB.BKR',
              shp_qty: 6,
              link: {
                type: 'external',
                product_link_url: 'https://www.lge.co.kr/monitors/19mb35pb?chatbot=y',
              },
              invoice_info: [
                {
                  SEQ: 1,
                  INVOICE_NO: '454435333391',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333391',
                },
                {
                  SEQ: 2,
                  INVOICE_NO: '454435333402',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333402',
                },
                {
                  SEQ: 3,
                  INVOICE_NO: '454435333413',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333413',
                },
                {
                  SEQ: 4,
                  INVOICE_NO: '454435333424',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333424',
                },
                {
                  SEQ: 5,
                  INVOICE_NO: '454435333435',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333435',
                },
                {
                  SEQ: 6,
                  INVOICE_NO: '454435333446',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333446',
                },
              ],
            },
          ],
          buttons: [
            {
              label: '배송 상세 보기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: '',
                mobile_url: '',
                enable: 'N',
              },
              enable: 'N',
            },
            {
              label: '배송 확인하기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                mobile_url:
                  'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                enable: 'Y',
              },
              enable: 'Y',
            },
          ],
        },
        {
          message_seq: 282725834,
          ord_shop: '2.베스트샵 서초점',
          ord_header_no: '1091237538',
          deliv_wish_ymd: '20231212',
          deliv_type: 'H',
          dev_status_type: 'prepare',
          tracking_url:
            'http://htlstest.lge.co.kr/dt/68ABF3ED67C7FF06C9227B0C9C25396C%7CTALK',
          model_info: [
            {
              ord_no: '1091237538-1.1.1',
              product_image_url:
                'https://ehtls.lge.co.kr/dt.static/img/DA_cleaner-A9.png',
              product_title: null,
              product_name: 'S9100SA.BKOR1',
              shp_qty: 14,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091237538-1.1.2',
              product_image_url:
                'https://ehtls.lge.co.kr/dt.static/img/DG_A9Stower-vacuum.png',
              product_title: null,
              product_name: 'T-ST1AN.AKOR',
              shp_qty: 14,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
          ],
          buttons: [
            {
              label: '배송 상세 보기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'http://htlstest.lge.co.kr/dt/68ABF3ED67C7FF06C9227B0C9C25396C%7CTALK',
                mobile_url:
                  'http://htlstest.lge.co.kr/dt/68ABF3ED67C7FF06C9227B0C9C25396C%7CTALK',
                enable: 'Y',
              },
              enable: 'Y',
            },
            {
              label: '배송 확인하기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                mobile_url:
                  'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                enable: 'Y',
              },
              enable: 'N',
            },
          ],
        },
        {
          message_seq: 282731691,
          ord_shop: '1.베스트샵 서초점',
          ord_header_no: '1091237539',
          deliv_wish_ymd: '20240101',
          deliv_type: 'H',
          dev_status_type: 'order',
          tracking_url:
            'http://htlstest.lge.co.kr/dt/68ABF3ED67C7FF06A7A777CA5A32AF0E%7CTALK',
          model_info: [
            {
              ord_no: '1091308792-1.1.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/CM_washtower.png',
              product_title: null,
              product_name: 'FX23KJN.AKOR',
              shp_qty: 1,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091308792-1.1.2',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/CM_washtower.png',
              product_title: null,
              product_name: 'RD20KJN.AKOR',
              shp_qty: 1,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
          ],
          buttons: [
            {
              label: '배송 상세 보기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'http://htlstest.lge.co.kr/dt/68ABF3ED67C7FF06A7A777CA5A32AF0E%7CTALK',
                mobile_url:
                  'http://htlstest.lge.co.kr/dt/68ABF3ED67C7FF06A7A777CA5A32AF0E%7CTALK',
                enable: 'Y',
              },
              enable: 'Y',
            },
            {
              label: '배송 확인하기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                mobile_url:
                  'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                enable: 'Y',
              },
              enable: 'N',
            },
          ],
        },
        {
          message_seq: 282757186,
          ord_shop: '3.베스트샵 서초점',
          ord_header_no: '1091303480',
          deliv_wish_ymd: '20231206',
          deliv_type: 'H',
          dev_status_type: 'shipping',
          tracking_url:
            'http://htlstest.lge.co.kr/dt/68ABF3ED67C7FF06467C5AA72B720EB9%7CTALK',
          model_info: [
            {
              ord_no: '1091303480-1.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/BO_microwave.png',
              product_title: null,
              product_name: 'F-14G39C.KMS',
              shp_qty: 1,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
          ],
          buttons: [
            {
              label: '배송 상세 보기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'http://htlstest.lge.co.kr/dt/68ABF3ED67C7FF06467C5AA72B720EB9%7CTALK',
                mobile_url:
                  'http://htlstest.lge.co.kr/dt/68ABF3ED67C7FF06467C5AA72B720EB9%7CTALK',
                enable: 'Y',
              },
              enable: 'Y',
            },
            {
              label: '배송 확인하기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                mobile_url:
                  'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                enable: 'Y',
              },
              enable: 'N',
            },
          ],
        },
        {
          message_seq: '',
          ord_shop: '4.베스트샵 서초점',
          ord_header_no: '1091009121',
          deliv_wish_ymd: '20231206',
          deliv_type: 'P',
          dev_status_type: 'complete',
          tracking_url: '',
          model_info: [
            {
              ord_no: '1091009121-1.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: '19MB35PB.BKR',
              shp_qty: 6,
              link: {
                type: 'external',
                product_link_url: 'https://www.lge.co.kr/monitors/19mb35pb?chatbot=y',
              },
              invoice_info: [
                {
                  SEQ: 1,
                  INVOICE_NO: '454435333391',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333391',
                },
                {
                  SEQ: 2,
                  INVOICE_NO: '454435333402',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333402',
                },
                {
                  SEQ: 3,
                  INVOICE_NO: '454435333413',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333413',
                },
                {
                  SEQ: 4,
                  INVOICE_NO: '454435333424',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333424',
                },
                {
                  SEQ: 5,
                  INVOICE_NO: '454435333435',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333435',
                },
                {
                  SEQ: 6,
                  INVOICE_NO: '454435333446',
                  TRANS_CORP_NM: '한진택배',
                  TRACKING_URL:
                    'http://www.hanjinexpress.hanjin.net/customer/hddcw18.tracking?w_num=454435333446',
                },
              ],
            },
          ],
          buttons: [
            {
              label: '배송 상세 보기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: '',
                mobile_url: '',
                enable: 'N',
              },
              enable: 'N',
            },
            {
              label: '배송 확인하기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                mobile_url:
                  'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                enable: 'Y',
              },
              enable: 'Y',
            },
          ],
        },
        {
          message_seq: '',
          ord_shop: '7.베스트샵 서초점',
          ord_header_no: '1091009120',
          deliv_wish_ymd: '',
          deliv_type: 'P',
          dev_status_type: 'shipping',
          tracking_url: '',
          model_info: [
            {
              ord_no: '1091212219-1.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'NKHKCNNN1A3.AKOJW1N',
              shp_qty: 7,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-2.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'NKHKCNNN1A4.AKOJW1N',
              shp_qty: 7,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-3.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'CLHK12FG1A7.AKORS2N',
              shp_qty: 6,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-3.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'CLHK12FG1A7.AKORS2N',
              shp_qty: 6,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-4.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'CLHK12FG1AC.AKORS2N',
              shp_qty: 18,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-4.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'CLHK12FG1AC.AKORS2N',
              shp_qty: 12,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-5.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'NKHKCNNN1A2.AKORS1N',
              shp_qty: 25,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-5.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'NKHKCNNN1A2.AKORS1N',
              shp_qty: 25,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-6.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'NSHKCENG1C1.AKKRS1N',
              shp_qty: 5,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-6.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'NSHKCENG1C1.AKKRS1N',
              shp_qty: 5,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-7.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'NSHKCENG1C2.AKKRS1N',
              shp_qty: 5,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-8.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'NAHKCCCN1A8.AKORS1N',
              shp_qty: 40,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091212219-9.1',
              product_image_url: 'https://ehtls.lge.co.kr/dt.static/img/',
              product_title: null,
              product_name: 'NAHKCCCN1A8.AKORS2N',
              shp_qty: 15,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
          ],
          buttons: [
            {
              label: '배송 상세 보기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: '',
                mobile_url: '',
                enable: 'N',
              },
              enable: 'N',
            },
            {
              label: '배송 확인하기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                mobile_url:
                  'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                enable: 'Y',
              },
              enable: 'Y',
            },
          ],
        },
        {
          message_seq: '',
          ord_shop: '5.베스트샵 서초점',
          ord_header_no: '1091327030',
          deliv_wish_ymd: '20231206',
          deliv_type: 'H',
          dev_status_type: 'prepare',
          tracking_url: '',
          model_info: [
            {
              ord_no: '1091327030-1.1.1',
              product_image_url:
                'https://ehtls.lge.co.kr/dt.static/img/home_ic_device_ventilation_off.svg',
              product_title: null,
              product_name: 'PW061205K01.AKOR',
              shp_qty: 1,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091327030-1.1.2',
              product_image_url:
                'https://ehtls.lge.co.kr/dt.static/img/home_ic_device_ventilation_off.svg',
              product_title: null,
              product_name: 'SW13AKAU.AKOR',
              shp_qty: 1,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
            {
              ord_no: '1091327030-1.1.3',
              product_image_url:
                'https://ehtls.lge.co.kr/dt.static/img/BD_airconditioner-wall.png',
              product_title: null,
              product_name: 'SW13BAKWAN.AKOR',
              shp_qty: 1,
              link: {
                type: 'external',
                product_link_url: null,
              },
              invoice_info: [],
            },
          ],
          buttons: [
            {
              label: '배송 상세 보기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: '',
                mobile_url: '',
                enable: 'N',
              },
              enable: 'Y',
            },
            {
              label: '배송 확인하기',
              speech: '',
              type: 'action_frontend',
              parameters: {
                action: 'external',
                url: 'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                mobile_url:
                  'https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillSch.do?mCode=MN038',
                enable: 'Y',
              },
              enable: 'N',
            },
          ],
        },
      ],
    },
  ],
};

/**
 * ViewModel Class
 * - UI View에 맞게 데이터를 가공하거나 해당 기능을 제공
 */
const DataProvider = ({
  channel,
  channelParams,
  countryCode,
  children,
  stage,
  projectCode,
  languageCode,
  client,
}) => {
  const [debugOpen, setDebugOpen] = useState(false);
  const { addToast } = useToasts();

  function setIsLast(convArray, isLast) {
    if (!convArray || !Array.isArray(convArray) || convArray.length <= 0) return;
    convArray[convArray.length - 1]['isLast'] = isLast;
  }

  function addConversation(
    conversationArray,
    isMine,
    dialog = null,
    deleteLoading = false
  ) {
    // conversationArray.unshift(makeDateMessage(isMine));

    setContext((prevState) => {
      if (deleteLoading) {
        prevState.conversations = prevState.conversations.filter(
          (conversation) => !conversation.loading
        );
      }
      setIsLast(prevState.conversations, false);
      let tempConv = [
        ...prevState.oldConversations,
        ...prevState.conversations,
        ...conversationArray,
      ];
      setIsLast(tempConv, true);

      let oldConv = [],
        newConv = [];
      tempConv.forEach((conv, index) => {
        // if (index < tempConv.length - 40) {
        //   oldConv.push(conv);
        // } else {
        //   newConv.push(conv);
        // }

        if (index < tempConv.length - 40) {
          conv.isOld = true;
        } else {
          conv.isOld = false;
        }
        newConv.push(conv);
      });

      let tempObj = {
        ...prevState,
        oldConversations: oldConv,
        conversations: newConv,
      };
      if (dialog) {
        tempObj['dialog'] = dialog;
      }
      prevState.scroll(true);
      return tempObj;
    });
  }

  const setShowOldConversations = (show) => {
    setContext((prevState) => {
      if (prevState.isShowOldConversations !== show) {
        return { ...prevState, isShowOldConversations: show };
      } else {
        return prevState;
      }
    });
  };

  // 웹소켓 관련 변수
  const websocketRef = useRef(null);
  const reconnectAttemptsRef = useRef(0); // 재연결 시도 횟수
  const maxReconnectAttempts = 5; // 최대 재연결 시도
  const reconnectInterval = 5000; // 5초 간격

  const connectWebSocket = () => {
    setContext((prevState) => {
      if (websocketRef.current) {
        console.log('[CONNECT_WEBSOCKET] close previous websocket connection');
        websocketRef.current.close();
      } else {
        console.log('[CONNECT_WEBSOCKET] no websocketconn is exist');
      }
      const queryString = makeWebSocketQueryString(prevState.sessionId);
      const websocketUrl = `${window[client].chatbot.pushManager}?${queryString}`;
      let socketConn = new WebSocket(websocketUrl);

      socketConn.onopen = webSocketOnOpen;
      socketConn.onmessage = webSocketOnMessage;
      socketConn.onclose = webSocketOnClose;

      websocketRef.current = socketConn;

      prevState.log(prevState, 'login', {
        event_type: 'login_success',
        err_msg: '',
        timestamp: moment().unix(),
        session_id: prevState.sessionId,
      });

      return {
        ...prevState,
        websocketConn: socketConn,
      };
    });
  };

  const webSocketOnOpen = () => {
    console.log('웹소켓 연결 성공!');
    reconnectAttemptsRef.current = 0; // 재연결 시도횟수 초기화
  };

  const webSocketOnMessage = (event) => {
    let response = event.data ? JSON.parse(event.data) : '';
    console.log('[WEBSOCKET][onmessage]', response);
    let responseArray = [];
    try {
      responseArray = convertMessage(response?.layouts[client].items);
    } catch (error) {
      console.log(error);
    }
    // 일반 대화 처리
    const conversationArray = responseArray.filter(
      (responseItem) => responseItem.type.toUpperCase() !== 'ACTION'
    );
    conversationArray.unshift(makeDateMessage(false));
    addConversation(conversationArray, false, response.dialog, true);

    // ACTION 분기 처리
    const actionArray = responseArray.filter(
      (response) => response.type.toUpperCase() === 'ACTION'
    );
    addAction(actionArray);
    context.scroll(true);
  };

  const webSocketOnClose = (event) => {
    console.log('[WEBSOCKET][onclose]', JSON.stringify(event));

    context.log(context, 'login', {
      event_type: 'login_disconnect',
      err_msg: 'websocket is disconnected',
      timestamp: moment().unix(),
      session_id: context.sessionId,
    });

    if (reconnectAttemptsRef.current < maxReconnectAttempts) {
      setTimeout(() => {
        reconnectAttemptsRef.current++;
        console.log(`웹소켓 재연결 시도 (${reconnectAttemptsRef.current})`);
        connectWebSocket();
      }, reconnectInterval);
    } else {
      console.log('최대 재연결 횟수 도달');
    }
  };

  // 포그라운드/온라인 감지 이벤트 등록하는 useEffect
  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        if (websocketRef.current?.readyState !== WebSocket.OPEN) {
          console.log('포그라운드 복귀, 재연결');
          // context.request(context, context.string.chat.restartConversation, 'button');
          // setTimeout(function () {
          //   try {
          //     if (context?.request && typeof context.request === 'function') {
          //       context.request(
          //         context,
          //         context.string.chat.restartConversation,
          //         'button'
          //       );
          //     } else {
          //       alert('context.request 가 정의되지 않았습니다.');
          //     }
          //   } catch (e) {
          //     alert('오류: ' + e.message);
          //   }
          // }, 200);
          connectWebSocket();
        }
      }
    };

    const handleOnline = () => {
      if (websocketRef.current?.readyState !== WebSocket.OPEN) {
        console.log('온라인 상태, 재연결');
        connectWebSocket();
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('online', handleOnline);

    // 언마운트 시 정리
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('online', handleOnline);
      if (websocketRef.current) websocketRef.current.close();
    };
  }, []);

  const makeWebSocketQueryString = (sessionId) => {
    const queryString = [];
    if (sessionId) {
      queryString.push(`x-session-id=${sessionId}`);
    } else if (context.sessionId) {
      queryString.push(`x-session-id=${context.sessionId}`);
    } else {
      throw new Error("No session id exist - can't connect websocket");
    }

    if (context.channel) {
      queryString.push(`x-channel=${context.channel}`);
    }

    const branchCode = context.countryCode === 'kr' ? 'LGEKR' : 'LGEAI';
    queryString.push(`x-branch=${branchCode}`);
    queryString.push(`x-country-code=${context.countryCode}`);
    return queryString.join('&');
  };

  function addAction(actionArray) {
    actionArray.forEach((action) => {
      switch (action.action.code.toUpperCase()) {
        case 'AUTOCOMPLETE':
          input.autoComplete.setEnable(true, {
            searchType: action?.parameters?.autocomplete_type,
            product_code: action?.parameters?.cs_product_code,
          }); //action?.parameters);
          break;
        case 'LOCATION':
          setLocation();
          break;

        /* remove - thinq app dependency
        case "TOKEN_EXPIRED":
          const errorRes = { status: { statusCode: 401 } };
          errorHandler(context, errorRes);
          break;
        case "CLIENT_REFRESH":
          refreshAccessToken();
          break;
        */
        case 'CHAT_END':
          let list_items = [
            {
              label: context.string.chat.restartConversation,
              speech: context.string.chat.restartConversation,
              frontActionFunc: restartConversation,
            },
          ];
          let errorText = context.string.chat.sessionTimeout;

          let slMessage = makeSLMessage(false, errorText, list_items, true);

          const dateMsg = makeDateMessage(false);
          addConversation([dateMsg, slMessage], false, null, true);
          endConversation();
          break;

        case 'TERMINATE':
          if (action.parameters.items[0].dim === true) {
            endConversation();
          }
          setContext((prevState) => {
            return {
              ...prevState,
              isUserAction: false,
            };
          });
          sendUserActionToApp(false);
          break;
        case 'STOP':
          if (action.parameters.items[0].dim === true) {
            endConversation();
          }
          break;
        case 'CONNECT_WEBSOCKET':
          try {
            connectWebSocket();
          } catch (err) {
            console.log('[addAction][CONNECT_WEBSOCKET]', ' Failed ', err);
            context.log(context, 'login', {
              event_type: 'login_fail',
              err_msg: err.toString(),
              timestamp: moment().unix(),
              session_id: context.sessionId,
            });
          }
          break;

        case 'CHATTING_STATUS':
          setContext((prevState) => {
            const status_str = action?.parameters?.status_str;
            return {
              ...prevState,
              chattingStatus: status_str,
            };
          });
          break;

        case 'CALL_INTENT':
          callIntent(action.parameters, action.expect);
          break;

        default:
          break;
      }
      console.log('Action', action);
    });
  }

  // function refreshAccessToken() {
  //   if (context.userAgent.deviceType !== "mobile") {
  //     console.log("refreshing access_token is available in mobile only");
  //     return;
  //   }
  //   return new Promise((resolve) => {
  //     var timer;
  //     window.NativeCallback.setAccessToken = (data) => {
  //       setContext((prevState) => {
  //         console.log(">> refresh access_token");
  //         console.log(
  //           "[old.access_token]",
  //           // prevState.channelParams.access_token
  //         );
  //         console.log("[new.access_token]", data.access_token);
  //         // prevState.channelParams.access_token = data.access_token;
  //         return { ...prevState };
  //       });
  //       clearTimeout(timer);
  //       restartConversation();
  //       window.NativeCallback.setAccessToken = () => {};
  //       resolve(data.access_token);
  //     };
  //     if (window.NativeInterface) {
  //       window.NativeInterface.getNewAccessToken(
  //         "window.NativeCallback.setAccessToken"
  //       );
  //       timer = setTimeout(() => {
  //         console.log("[refreshAccessToken] timeout");
  //         window.NativeCallback.setAccessToken = () => {};
  //         const errorRes = { status: { statusCode: 400 } };
  //         errorHandler(context, errorRes);
  //         context.scroll(true);
  //         addToast("Token Refresh Timeout!", { appearance: "error" });
  //       }, 10 * 1000);
  //     } else {
  //       console.log("NativeInterface is not supported");
  //       addToast("NativeInterface is not supported!", { appearance: "error" });
  //     }

  //     // 대화 다시 시작 먼저 표시
  //     const userMessage = makeTXMessage(
  //       true,
  //       context.string.chat.restartConversation,
  //       false
  //     );
  //     if (window.navigator.onLine === false) {
  //       userMessage.online = false;
  //       userMessage.loading = false;
  //       userMessage.action = (contextTx, callbackTx) => {
  //         if (window.navigator.onLine === true) {
  //           startConversation(contextTx);
  //           callbackTx(true);
  //         } else {
  //           setTimeout(() => {
  //             callbackTx(false);
  //           }, 2000);
  //         }
  //       };
  //     }
  //     const dateMsg = makeDateMessage(false);
  //     addConversation([dateMsg, userMessage],false);
  //     context.scroll(true);
  //   });
  // }

  function errorHandler(context, errorRes) {
    const statusCode = errorRes.status.statusCode;
    let list_items = [
      {
        label: context.string.chat.restartConversation,
        speech: context.string.chat.restartConversation,
        frontActionFunc: restartConversation,
      },
    ];
    let slMessage = null;

    let errorText = context.string.chat.responseError;
    if (statusCode === 401) {
      errorText = context.string.chat.sessionTimeout;
    }

    slMessage = makeSLMessage(false, errorText, list_items, true);

    const dateMsg = makeDateMessage(false);
    addConversation([dateMsg, slMessage], false, null, true);
    endConversation();
  }

  /**
   * ThinQ App 이 연결된 경우 인터페이스가 있는지 확인
   */
  const isNativeAppEnabled = () => {
    if (window.NativeInterface) {
      return (
        window.NativeInterface.getLocationStatus &&
        window.NativeInterface.getLocationValue &&
        window.NativeInterface.getNewAccessToken
      );
    }
    return false;
  };

  /**
   * ThinQ App 에 Location 권한 상태를 확인
   * - 모바일이 아닌 경우는 Geolocation 을 확인
   */
  const getLocationStatus = () => {
    if (context.userAgent.deviceType !== 'mobile') {
      console.log('getLocationStatus is available in mobile only');
      return new Promise((resolve) => {
        resolve({ Permission: true, Status: true });
      });
    }
    return new Promise((resolve) => {
      var timer;
      window.NativeCallback.getLocationStatus = (data) => {
        console.log('[getLocationStatus]', data);
        if (typeof data === 'string') {
          data = JSON.parse(data);
        }
        clearTimeout(timer);
        window.NativeCallback.getLocationStatus = () => {};
        resolve(data);
      };

      if (window.NativeInterface) {
        window.NativeInterface.getLocationStatus(
          'window.NativeCallback.getLocationStatus'
        );
        timer = setTimeout(() => {
          console.log('[getLocationStatus] timeout');
          window.NativeCallback.getLocationStatus = () => {};
          const errorRes = { status: { statusCode: 400 } };
          errorHandler(context, errorRes);
          context.scroll(true);
        }, 10 * 1000);
      }
    });
  };

  const setGPSTimeout = () => {
    return setTimeout(() => {
      console.log('[getLocationValue] timeout');
      window.NativeCallback.getLocationValue = () => {};
      const errorRes = { status: { statusCode: 400 } };
      errorHandler(context, errorRes);
      context.scroll(true);
    }, 10 * 1000);
  };
  const getLocationValue = () => {
    if (context.userAgent.deviceType !== 'mobile') {
      console.log('getLocationValue (GPS) is available in mobile only');
      return new Promise((resolve) => {
        resolve({ lat: 37.5012103, lng: 127.0246143 });
      });
    }
    return new Promise((resolve) => {
      var timer;
      window.NativeCallback.getLocationValue = (data) => {
        console.log('[getLocationValue]', data);
        if (typeof data === 'string') {
          data = JSON.parse(data);
        }
        clearTimeout(timer);
        window.NativeCallback.getLocationValue = () => {};
        resolve(data);
      };

      if (window.NativeInterface) {
        window.NativeInterface.getLocationValue('window.NativeCallback.getLocationValue');
        timer = setGPSTimeout();
      }
    });
  };

  const getLocationValueLGEAPP = (type) => {
    if ((type === 'ios' && !window.webkit) || (type === 'android' && !window.android)) {
      console.log('getLocationValue (GPS) is available in LGE.COM App');
      throw new Error(
        `[getLocationValueLGEAPP] getLocationValue (GPS) is available in LGE.COM App`
      );
    }

    return new Promise((resolve, reject) => {
      let timer = null;
      window.NativeCallback.getLocationValue = (data) => {
        console.log('[getLocationValue]', data);
        if (timer) {
          clearTimeout(timer);
        }
        window.NativeCallback.getLocationValue = () => {};
        resolve(data);
      };

      try {
        if (type === 'android') {
          let appGeoAgree = window.android.getLocationActive();
          // addToast(`[LGEAPP] getLocationActive result : ${appGeoAgree}`, { appearance: "error" })
          if (appGeoAgree === 'Y') {
            window.android.getLocation('window.NativeCallback.getLocationValue');
            timer = setGPSTimeout();
          } else {
            reject("[LGEAPP] getLocationActive is 'N', need permission");
            //동의 pop up 출력
            // window.android.setLocationActive('Y');

            //GPS좌표얻기
            // window.android.getLocation('window.NativeCallback.getLocationValue');
          }
        } else if (type === 'ios') {
          // var jsonString = JSON.stringify({ command: 'setGPS', value: 'Y' });
          // window.webkit.messageHandlers.callbackHandler.postMessage(jsonString);

          //GPS좌표얻기
          let obj = {
            command: 'getGPS',
            callback: 'window.NativeCallback.getLocationValue',
          };
          let jsonString = JSON.stringify(obj);
          window.webkit.messageHandlers.callbackHandler.postMessage(jsonString);

          timer = setGPSTimeout();
        }
      } catch (error) {
        console.log(`[getLocationValueLGEAPP] getLocationValue failed => `, error);
        // addToast(`[LGEAPP] getLocationValue exception : ${error}`, { appearance: "error" })
        if (timer) {
          clearTimeout(timer);
        }
        window.NativeCallback.getLocationValue = () => {};
        reject(error);
      }
    });
  };

  const callIntent = (parameters, expect) => {
    setContext((prevState) => {
      postData(prevState, '', 'text', parameters, expect);
      return { ...prevState };
    });
  };

  const setLocation = () => {
    // for loading spinner
    const dateMsg = makeDateMessage(false, false, true);
    const userMessage = makeTXMessage(false, '', true, dateMsg.id);
    dateMsg.TXMsgId = userMessage.id;
    addConversation([dateMsg, userMessage]);

    setContext((prevState) => {
      prevState.scroll();
      // INITIALIZE Location
      prevState.location = {
        permission: false,
        status: false,
        latitude: '',
        longitude: '',
      };

      // CHECK Native APP GPS Enabled.
      if (isNativeAppEnabled()) {
        getLocationStatus().then((status) => {
          // 1. CONFIRM Permission
          prevState.location.permission = status.Permission;
          prevState.location.status = status.Status;

          // iOS TEST
          // addTXMessage(true, `1) type status: ${typeof status.Permission}, status: ${typeof status.Status}`);

          if (status.Permission === true && status.Status === true) {
            // 1-1. GET GPS Permission Successfully.
            getLocationValue().then((value) => {
              // GET GPS Value.
              prevState.location.latitude = value.lat || '';
              prevState.location.longitude = value.lng || '';

              // iOS TEST
              // addTXMessage(true, `2) lat: ${value.lat}, lng: ${value.lng}`);

              const parameters = {};
              if (prevState.location.latitude !== '')
                parameters.latitude = prevState.location.latitude;
              if (prevState.location.longitude !== '')
                parameters.longitude = prevState.location.longitude;

              postData(prevState, '', 'text', parameters, null, true);
            });
          } else {
            // 1-2. FAILED to get GPS Permission.

            postData(prevState, '', 'text', null, null, true);
          }
        });
      } else if (prevState.userAgent.isLGEAPP) {
        const osName = prevState.userAgent.os.toLowerCase();
        getLocationValueLGEAPP(osName)
          .then((value) => {
            // addToast(`[LGEAPP] getLocationValue result : ${value}`, { appearance: "error" })
            let currentLocation = value.split(',');
            prevState.location.latitude = currentLocation[0];
            prevState.location.longitude = currentLocation[1];

            const parameters = {};
            if (prevState.location.latitude !== '')
              parameters.latitude = prevState.location.latitude;
            if (prevState.location.longitude !== '')
              parameters.longitude = prevState.location.longitude;

            postData(prevState, '', 'text', parameters, null, true);
          })
          .catch((error) => {
            postData(prevState, '', 'text', null, null, true);
          });
      } else {
        // 2. CONFIRM function.
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(
            (success) => {
              // 2-1. GET GPS Value successfully.
              console.log('[getCurrentPosition] success', success);
              prevState.location.permission = true;
              prevState.location.status = true;
              prevState.location.latitude = success.coords.latitude || '';
              prevState.location.longitude = success.coords.longitude || '';

              // iOS TEST
              // addTXMessage(true, `3) lat: ${success.coords.latitude}, lng: ${success.coords.longitude}`);

              const parameters = {};
              if (prevState.location.latitude !== '')
                parameters.latitude = prevState.location.latitude;
              if (prevState.location.longitude !== '')
                parameters.longitude = prevState.location.longitude;
              postData(prevState, '', 'text', parameters, null, true);
            },
            (error) => {
              // 2-2. FAILED to get GPS value.
              console.log('[getCurrentPosition] error', error);

              postData(prevState, '', 'text', null, null, true);

              // iOS TEST
              //  addTXMessage(true, `4) error ${error}`);
            },
            { enableHighAccuracy: false, maximumAge: 3000, timeout: 60000 * 10 }
          );
        } else {
          // 3. NOT Supported.
          console.log(
            '[getCurrentPosition] NOT Supported (window.natvigator.geolocation)'
          );

          postData(prevState, '', 'text', null, null, true);

          // iOS TEST
          // addTXMessage(true, `5) Not Supported`);
        }
      }
      return { ...prevState };
    });
  };

  const setLocationDummy = () => {
    console.log('[setLocationDummy]', '강남구 역삼동');
    if (!window.NativeInterface) {
      window.NativeInterface = {};
    }
    window.NativeInterface.getLocationStatus = function () {
      window.NativeCallback.getLocationStatus({
        Permission: true,
        Status: true,
      });
    };
    window.NativeInterface.getLocationValue = function () {
      window.NativeCallback.getLocationValue({
        lat: 37.5012103,
        lng: 127.0246143,
      }); // 강남구 역삼동
    };
  };

  async function postData(
    context,
    content,
    contentType,
    parameters = null,
    expect = null,
    noLoading = false
  ) {
    context.scroll(false);

    const dateMsg = makeDateMessage(true, content === '');
    const userMessage = makeTXMessage(true, content, false, dateMsg.id);

    // 230421 minseok.seo - delete button이 dateMsg에 존재해서 tx, date를 같이 지우기 위해 서로의 id를 저장
    dateMsg.TXMsgId = userMessage.id;

    if (window.navigator.onLine === false) {
      userMessage.online = false;
      userMessage.loading = false;
      dateMsg.online = false;
      addConversation([dateMsg, userMessage], true);
      return;
    }

    addConversation([dateMsg, userMessage], true);

    // 자동 완성 기능 종료
    // setAutoComplete(false);
    input.autoComplete.setEnable(false);
    // addToast(`[ACTION][AUTOCOMPLETE] : De-Activate`, { appearance: "error" })

    // 일단 딤처리를 푼다..
    releaseDim();

    // 서버에 요청
    send('post', context, content, contentType, null, 'dialog', parameters, expect).then(
      (res) => {
        // 서버 응답 처리
        console.log('res', res);

        let responseArray = [];
        userMessage.loading = false;

        const statusCode = res.status.statusCode;
        if (statusCode !== 200) {
          errorHandler(context, res);
        } else {
          // Debug Message
          let debug = res.response.layouts
            ? res.response.layouts[context.client].debug
            : {};
          if (
            context.debug &&
            Object.keys(debug).length !== 0 &&
            debug.constructor === Object
          ) {
            let debugArray = convertDebugMessage(debug);
            debugArray.unshift(makeDateMessage(false));
            addConversation(debugArray, false);
          }

          try {
            responseArray = convertMessage(
              res.response.layouts ? res.response.layouts[context.client].items : []
            );
          } catch (error) {
            console.log(error);
          }
          // 일반 대화 처리
          const conversationArray = responseArray.filter(
            (response) => response.type.toUpperCase() !== 'ACTION'
          );
          if (conversationArray.length > 0) {
            conversationArray.unshift(makeDateMessage(false));
          }
          addConversation(conversationArray, false, res.response.dialog, true);

          // ACTION 분기 처리
          const actionArray = responseArray.filter(
            (response) => response.type.toUpperCase() === 'ACTION'
          );
          addAction(actionArray);
        }
        context.scroll(true);
      }
    );

    // 데이터 로딩 중 메시지
    userMessage.loading = false;

    if (noLoading === false) {
      const waitMessage = makeTXMessage(false, content, true);
      const loadingDateMsg = makeDateMessage(false, false, true);
      addConversation([loadingDateMsg, waitMessage], false);
    }
    setContext((prevState) => {
      if (prevState.isUserAction !== true) {
        sendUserActionToApp(true);
      }
      return {
        ...prevState,
        isUserAction: true,
      };
    });
  }

  const sendUserActionToApp = (action) => {
    if (window.NativeInterface && window.NativeInterface.setIsUserAction) {
      window.NativeInterface.setIsUserAction(action);
    }
  };

  function addTXMessage(isMine, content, isDebug = false) {
    context.scroll(false);

    if (isDebug) {
      let debugArray = convertDebugMessage(content);
      addConversation(debugArray, isMine);
    } else {
      // 사용자가 입력한 메시지
      const userMessage = makeTXMessage(isMine, content, false);
      const dateMessage = makeDateMessage(isMine);
      addConversation([dateMessage, userMessage], isMine);
    }

    context.scroll(true);
  }

  function addTLMessage(isMine, content, link) {
    context.scroll(false);

    const dateMessage = makeDateMessage(isMine);
    const userMessage = makeTLMessage(isMine, content, link);
    addConversation([dateMessage, userMessage], isMine);

    context.scroll(true);
  }

  function addSGMessage(isMine, content, buttons, isGrid) {
    context.scroll(false);

    const dateMessage = makeDateMessage(isMine);
    const userMessage = makeSGMessage(isMine, content, buttons, isGrid);
    addConversation([dateMessage, userMessage], isMine);

    context.scroll(true);
  }

  function addSLMessage(isMine, text, list_items) {
    context.scroll(false);

    let slMessage = makeSLMessage(isMine, text, list_items);

    const dateMsg = makeDateMessage(isMine);
    addConversation([dateMsg, slMessage], isMine);

    context.scroll(true);
  }

  const setOpenCustomerFeedback = (open, force = false) => {
    setContext((prevState) => {
      prevState.openCustomerFeedback = open;
      if (!open && !force) prevState.onCloseCustomerFeedback();
      return { ...prevState };
    });
  };

  const setOnCloseCustomerFeedback = (callback) => {
    setContext((prevState) => {
      prevState.onCloseCustomerFeedback = callback;
      return { ...prevState };
    });
  };

  const setUserNo = (userNo) => {
    setContext((prevState) => {
      prevState.userNo = userNo;
      return { ...prevState };
    });
  };

  // Token Issue API
  async function requestToken(data) {
    const res = await getToken(data);
    const thinqAIToken = res.access_token;

    console.log('requestToken - token:', thinqAIToken);

    return thinqAIToken;
  }

  // 테스트 데이터 호출 용
  const testData = (type) => {
    context.scroll(false);
    const testMessage = testMessages[type.toUpperCase()];

    if (type.toUpperCase() === 'AUTOCOMPLETE') {
      addAction(testMessage);
    } else {
      // addConversation(testMessage);

      // 일반 대화 처리
      const conversationArray = testMessage.filter(
        (response) => response.type.toUpperCase() !== 'ACTION'
      );
      conversationArray.unshift(makeDateMessage(false));
      addConversation(conversationArray, false);

      // ACTION 분기 처리
      const actionArray = testMessage.filter(
        (response) => response.type.toUpperCase() === 'ACTION'
      );
      addAction(actionArray);
    }

    context.scroll(true);
    if (type.toUpperCase() === 'TERMINATE') {
      endConversation();
    }
  };

  // 디버그 데이터 호출
  const debugData = async (content) => {
    // ST, QA 형상만 허용됨
    if (!window[client].chatbot.debug) {
      return;
    }

    if (content.startsWith('/debug_on')) {
      addToast('DEBUG ON!', { appearance: 'warning' });
      setContext((prevState) => {
        prevState.debug = true;
        return { ...prevState };
      });
    } else if (content.startsWith('/debug_off')) {
      addToast('DEBUG OFF!', { appearance: 'warning' });
      setContext((prevState) => {
        prevState.debug = false;
        return { ...prevState };
      });
    } else if (content === '/h') {
      setDebugOpen(true);
    } else if (content.startsWith('/e_')) {
      // 강제로 서버 에러 발생 시 Status Code 입력 ex) /e_401 이면 401 에러 발생으로 간주
      const code = content.split('_')[1];
      const errorRes = { status: { statusCode: Number(code) } };
      errorHandler(context, errorRes);
    } else if (content === '/h_gps') {
      setLocationDummy();
    } else if (content === '/h_gps_status') {
      const status = await getLocationStatus();
      if (status) {
        addToast(
          `[GPS Status] permission: ${status.Permission} status: ${status.Status}`,
          { appearance: 'info' }
        );
      }
    } else if (content === '/h_gps_value') {
      const value = await getLocationValue();
      if (value) {
        addToast(`[GPS Value] lat: ${value.lat} lng: ${value.lng}`, {
          appearance: 'success',
        });
      }
    } else if (content === '/h_device_test') {
      setContext((prevState) => {
        const id = prevState.dialog.context.devices[0].id;
        console.log('device test', id);
        window.NativeInterface.goProductPage(id);
        return prevState;
      });
    } else if (content === '/h_reward') {
      window.NativeInterface.open('thinqapp://commerce?path=Reward&from=Chatbot');
    } else if (content === '/h_reward_mission') {
      window.NativeInterface.open(
        `thinqapp://commerce?path=Reward&from=Chatbot&url=${encodeURIComponent(
          'https://st-kr-front.qreward.lge.com/mission'
        )}`
      );
    } else if (content === '/h_diagnosis') {
      window.NativeInterface.open('thinqapp://smartdiagnosis');
    } else if (content === '/h_csreserve') {
      window.NativeInterface.open('thinqapp://csreserve?call=Push');
    } else if (content.startsWith('/h_csreserve_')) {
      const type = content.split('_')[2];
      window.NativeInterface.open(
        `thinqapp://csreserve?call=Push&reserveType=reserveType${type}`
      );
    } else if (content.startsWith('/h_thinqapp_')) {
      const type = content.split('_')[2];
      window.NativeInterface.open(`thinqapp://${type}`);
    } else if (content === '/h_manual') {
      const testUrl =
        '"' +
        'http://manual-chatai-st-kr.lgthinq.com/?channel=thinq&channel_parameters=ewogICAgImNsaWVudF9pZCI6ICI3cGJUek53TFBsdnppN3hwdnM3Zld1IiwKICAgICJjaGF0X2lkIjogIkU1R2V6Sl95X0ZnMGdBaEZQN1pKUE5CLW9vdGdnZGFfNjF2N0JSNjBwSkZOaElqTS1LY2pqY3hIbUVIWXZBaHBrZ01YUzBVZXNqekgyelRHckVMREtRPT0iLAogICAgImJyYW5jaCI6ICJMR0VLUiIsCiAgICAiY291bnRyeV9jb2RlIjogImtyIiwKICAgICJsYW5ndWFnZV9jb2RlIjogImtvIiwKICAgICJwcm9kdWN0X2dyb3VwX2NvZGUiOiAiV00iLAogICAgInByb2R1Y3RfZ3JvdXBfbmFtZSI6ICLshLjtg4HquLAiLAogICAgInByb2R1Y3RfY29kZSI6ICJEUlciLAogICAgInByb2R1Y3RfbmFtZSI6ICLrk5zrn7wg7IS47YOB6riwIiwKICAgICJkZXZpY2VfY29kZSIgOiAiMjAxIiwKICAgICJkZXZpY2VfaWNvbiIgOiAiaWNfZGV2aWNlX2xpc3RfZnJvbnRfbG9hZF93YXNoZXJfZGVmYXVsdC5zdmciLAogICAgImRldmljZV9uYW1lIjogIu2KuOuhrOydtCIsCiAgICAic2FsZXNfbW9kZWwiOiAiRjI0VkRELkFLT1IiLAogICAgInRpbWVzdGFtcCI6IDE2NDcyMjk1MDgKfQ==' +
        '"';
      const urlBase64 = Base64.encodeURI(testUrl); // in encoded string with js-base64, padding(=) character is truncated
      const internalLink = 'thinqapp://inappbrowser?url=' + urlBase64 + '&target=new';

      // const urlBase64 = Base64.encodeURI(`"http://manual-chatai-st-kr.lgthinq.com/?channel=thinq&channel_parameters=ewogICAgImNsaWVudF9pZCI6ICI3cGJUek53TFBsdnppN3hwdnM3Zld1IiwKICAgICJjaGF0X2lkIjogIkU1R2V6Sl95X0ZnMGdBaEZQN1pKUE5CLW9vdGdnZGFfNjF2N0JSNjBwSkZOaElqTS1LY2pqY3hIbUVIWXZBaHBrZ01YUzBVZXNqekgyelRHckVMREtRPT0iLAogICAgImJyYW5jaCI6ICJMR0VLUiIsCiAgICAiY291bnRyeV9jb2RlIjogImtyIiwKICAgICJsYW5ndWFnZV9jb2RlIjogImtvIiwKICAgICJwcm9kdWN0X2dyb3VwX2NvZGUiOiAiV00iLAogICAgInByb2R1Y3RfZ3JvdXBfbmFtZSI6ICLshLjtg4HquLAiLAogICAgInByb2R1Y3RfY29kZSI6ICJEUlciLAogICAgInByb2R1Y3RfbmFtZSI6ICLrk5zrn7wg7IS47YOB6riwIiwKICAgICJkZXZpY2VfY29kZSIgOiAiMjAxIiwKICAgICJkZXZpY2VfaWNvbiIgOiAiaWNfZGV2aWNlX2xpc3RfZnJvbnRfbG9hZF93YXNoZXJfZGVmYXVsdC5zdmciLAogICAgImRldmljZV9uYW1lIjogIu2KuOuhrOydtCIsCiAgICAic2FsZXNfbW9kZWwiOiAiRjI0VkRELkFLT1IiLAogICAgInRpbWVzdGFtcCI6IDE2NDcyMjk1MDgKfQ=="`);
      // const testUrl = `thinqapp://inappbrowser?url=${urlBase64}&target=new`;
      console.log('Manual Q&A TEST URL', internalLink);
      window.NativeInterface.open(internalLink);
    } else {
      const data = {
        intent: 'THQ_HIDDEN_COMMAND',
        parameters: JSON.parse('{}'),
      };
      // const debugResult = await debug("hidden", context, data, content);
      const debugResult = await window[client].chatbot.debug.send(
        'hidden',
        context,
        data,
        content,
        moment().unix(),
        base62.v4()
      );

      console.log('Hidden Command', debugResult);
      addToast(`Hidden Command: ${content}`, { appearance: 'warning' });

      let resultItems = null;
      let resultDialog = '';

      resultDialog = debugResult.response.dialog;
      resultItems = debugResult.response.layouts[client].items;

      const responseArray = convertMessage(resultItems);

      console.log('[debug] - resultItems', resultItems);
      console.log('[debug] - responseArray', responseArray);

      // 일반 대화 처리
      const conversationArray = responseArray.filter(
        (response) => !response.type || response.type.toUpperCase() !== 'ACTION'
      );
      if (conversationArray.length > 0) {
        conversationArray.unshift(makeDateMessage(false));
      }
      addConversation(conversationArray, false, resultDialog);

      // ACTION 분기 처리
      const actionArray = responseArray.filter(
        (response) => response.type && response.type.toUpperCase() === 'ACTION'
      );
      addAction(actionArray);
      context.scroll(false);
    }
  };

  const handleDebugClose = () => {
    setDebugOpen(false);
  };

  const handleDebugOK = async (data) => {
    setDebugOpen(false);
    console.log('handleDebugOK', data);
    // let debugResult = await debug("conversation", context, data);
    if (!window[client].chatbot.debug) {
      return;
    }
    let debugResult = await window[client].chatbot.debug.send(
      'conversation',
      context,
      data,
      '',
      moment().unix(),
      base62.v4()
    );

    // Debug Message
    let debugRes = debugResult.response.layouts[client].debug;
    console.log('debug', debugRes);
    if (
      context.debug &&
      Object.keys(debugRes).length !== 0 &&
      debugRes.constructor === Object
    ) {
      let debugArray = convertDebugMessage(debugRes);
      debugArray.unshift(makeDateMessage(false));
      addConversation(debugArray, false);
    }

    console.log(debugResult);
    let resultItems = null;
    let resultDialog = '';

    resultDialog = debugResult.response.dialog;
    resultItems = debugResult.response.layouts[client].items;
    const conversationArray = convertMessage(resultItems);
    conversationArray.unshift(makeDateMessage(false));
    addConversation(conversationArray, false, resultDialog);
    context.scroll(false);
  };

  const request = async (
    context,
    content,
    contentType,
    parameters = null,
    expect = null
  ) => {
    if (Object.keys(testMessages).includes(content.toUpperCase())) {
      testData(content);
    } else if (
      content === '/h' ||
      content.startsWith('/debug') ||
      new RegExp('^/h_[a-z0-9_]+').exec(content) ||
      new RegExp('^/e_[a-z0-9_]+').exec(content)
    ) {
      debugData(content);
    } else {
      postData(context, content, contentType, parameters, expect);
    }
  };

  const log = async (context, type, data) => {
    const res = await postLog(context, type, data);
    console.log('[LOG] res', res);
  };

  const startSTT = async () => {
    console.log('startSTT', context);
    return thinqSTT(context.thinqAIToken);
  };

  // const initThinqAIToken = async () => {
  //   if (context.thinqAIToken !== null) return;
  //   let token = await requestToken();
  //   setContext((prevState) => {
  //     prevState.thinqAIToken = token;
  //     return { ...prevState };
  //   });
  // };

  const initSessionId = () => {
    let sessionId = base62.v4();

    console.log('initSessionId', sessionId);

    setContext((prevState) => {
      prevState.sessionId = sessionId;
      return { ...prevState };
    });
  };

  const initOS = () => {
    document.title = string[countryCode].title;
    setContext((prevState) => {
      prevState.userAgent.os = osName;
      prevState.userAgent.deviceType = isMobile ? 'mobile' : 'pc';
      prevState.userAgent.isLGEAPP = /LGEAPP|lgeapp\/[0-9\.]+$/.test(navigator.userAgent);
      return { ...prevState };
    });
  };

  const startConversation = async (context) => {
    releaseDim();

    console.log('[startConversation] context =', context);
    let res = null;
    try {
      res = await send(
        'post',
        context,
        '__CHATBOT_START_CONVERSATION__',
        'button',
        null,
        'start'
      );
    } catch (error) {
      console.log('[error]', error);
    }
    let responseArray = [];
    console.log('[startConversation]', res);
    const statusCode = res.status.statusCode;
    const resultStatus = res.status.code;
    if (statusCode !== 200 || resultStatus !== '0000') {
      errorHandler(context, res);
    } else {
      // Debug Message
      let debug = res.response.layouts ? res.response.layouts[context.client].debug : {};
      if (
        context.debug &&
        Object.keys(debug).length !== 0 &&
        debug.constructor === Object
      ) {
        let debugArray = convertDebugMessage(debug);
        debugArray.unshift(makeDateMessage(false));
        addConversation(debugArray, false);
      }

      try {
        responseArray = convertMessage(
          res.response.layouts ? res.response.layouts[context.client].items : [],
          true
        );
      } catch (error) {
        console.log(error);
      }
      // 일반 대화 처리
      const conversationArray = responseArray.filter(
        (response) => response.type.toUpperCase() !== 'ACTION'
      );

      // dont show date on startConversation
      // conversationArray.unshift(makeDateMessage(false));
      addConversation(conversationArray, false, res.response.dialog, true);

      // ACTION 분기 처리
      const actionArray = responseArray.filter(
        (response) => response.type.toUpperCase() === 'ACTION'
      );
      addAction(actionArray);
    }
    context.scroll(true);
  };

  const endConversation = () => {
    setContext((prevState) => {
      return {
        ...prevState,
        conversationEnd: true,
      };
    });
  };

  const restartConversation = () => {
    console.log('[Restart conversation]', context);
    initSessionId();
    setContext((prevState) => {
      startConversation(prevState);
      return { ...prevState, conversationStart: true };
    });
  };

  const releaseDim = () => {
    setContext((prevState) => {
      return {
        ...prevState,
        conversationEnd: false,
      };
    });
  };

  const deleteMessage = (msgIdArray) => {
    setContext((prevState) => {
      return {
        ...prevState,
        conversations: prevState.conversations.filter(
          // (conversation) => msgId !== conversation.id
          (conversation) => !msgIdArray.includes(conversation.id)
        ),
      };
    });
  };

  // 초기화 객체
  const initialState = {
    client,
    projectCode,
    languageCode,
    oldConversations: [],
    isShowOldConversations: false,
    setShowOldConversations: setShowOldConversations,
    conversations: [],
    request: request,
    scroll: () => {},
    countryCode: countryCode,
    string: string[countryCode],
    requestToken: requestToken,
    thinqAIToken: null,
    startSTT: startSTT,
    channel: channel,
    channelParams: channelParams,
    sessionId: '',
    deleteMessage: deleteMessage,
    stage: stage,
    conversationStart: false,
    conversationEnd: false,
    userAgent: {
      os: '',
      deviceType: '',
      isLGEAPP: null,
    },
    debug: false,
    dialog: {},
    addTXMessage: addTXMessage,
    addTLMessage: addTLMessage,
    addSGMessage: addSGMessage,
    addSLMessage: addSLMessage,
    location: {
      permission: false,
      status: false,
      latitude: '',
      longitude: '',
    },
    endConversation: endConversation,
    log: log,
    isUserAction: false,

    openCustomerFeedback: false,
    setOpenCustomerFeedback: setOpenCustomerFeedback,
    onCloseCustomerFeedback: () => {},
    setOnCloseCustomerFeedback: setOnCloseCustomerFeedback,
    userNo: '',
    setUserNo: setUserNo,
    sendUserActionToApp: sendUserActionToApp,
    websocketConn: null,
    chattingStatus: '',
    isSFDC: true,
  };

  const [context, setContext] = useState(initialState);
  const input = useContext(InputContext);

  // Fetch thinqAIToken
  useEffect(() => {
    console.log('end loading', Date.now());
    window.endLoading = Date.now();
    // initThinqAIToken();
    initSessionId();
    initOS();

    // 초기 파라미터 동작
    setContext((prevState) => {
      startConversation(prevState).then(() => {
        setContext((prev) => {
          if (prev.channelParams.params && prev.channelParams.params.mode === 'bypass') {
            request(
              prev,
              prev.channelParams.speech,
              'text',
              prev.channelParams.params.parameters,
              {
                mode: prev.channelParams.params.mode,
                intent: prev.channelParams.params.intent,
              }
            );
          } else if (prev.channelParams.speech) {
            postData(prev, prev.channelParams.speech, 'text');
          }
          return { ...prev, conversationStart: true };
        });

        console.log('complete loading', Date.now());
        window.completeLoading = Date.now();
      });
      return prevState;
    });
  }, []);

  if (!string.hasOwnProperty(countryCode)) {
    return <Error />;
  }

  return (
    <DataContext.Provider value={context}>
      {children}
      <Debug open={debugOpen} handleOk={handleDebugOK} handleClose={handleDebugClose} />
    </DataContext.Provider>
  );
};
export default DataProvider;
